import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Submitted_entries_receipt } from '../models/submitted_entries_receipt';
import { Submitted_entries_cheque_receipt } from '../models/submitted_entries_cheque_receipt';
import { Bill_item } from '../models/accounting/bill_item';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SubmitEntriesService {

  constructor(private http: HttpClient) { }

  submitHorseShowEntries(payment_token: string, customer_id: string, amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[], device_data: string): Promise<Submitted_entries_receipt> {

  	 let post_data = {
                data: {
                  type: 'submitted_horse_show_entries',
                  new: true,
                  attributes: { token: payment_token, customer_id: customer_id, amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list, additional_items: additional_item_list, device_data: device_data}
                  }
              };

              return new Promise((resolve, reject) => {

             return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

                     if(response.data && response.type=='submitted_entries_receipt') {
                         resolve(response.data);
                       } else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });

        });


  }

  submitHorseShowEntriesStripe(card_id: string, amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[], device_data: string): Promise<Submitted_entries_receipt> {

     let post_data = {
                data: {
                  type: 'submitted_horse_show_entries',
                  new: true,
                  attributes: { stripe_id: card_id, amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list, additional_items: additional_item_list, device_data: device_data}
                  }
              };

              return new Promise((resolve, reject) => {

             return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

                     if(response.data && response.type=='submitted_entries_receipt') {
                         resolve(response.data);
                       } else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });

        });


  }

  submitHorseShowEntriesWithChequePledge(amount: number, horse_show_id: string, entry_id_list: string[]): Promise<Submitted_entries_cheque_receipt> {

     let post_data = {
                data: {
                  type: 'submitted_horse_show_entries',
                  new: true,
                  attributes: { amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list }
                  }
              };

              return new Promise((resolve, reject) => {

             return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries_with_cheque',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

                     if(response.data && response.type=='submitted_entries_cheque_receipt') {
                         resolve(response.data);
                       } else {
                         if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : error);
                  }
             });

        });

  }

  submitHorseShowEntriesCanada(system_payment_method_id: string, amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[]): Promise<Submitted_entries_receipt> {

    const post_data = {
      data: {
        type: 'submitted_horse_show_entries',
        new: true,
        attributes: { system_payment_method_id: system_payment_method_id, amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list, additional_items: additional_item_list }
      }
    };

    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries_canada',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response.data && response.type === 'submitted_entries_receipt') {
            resolve(response.data);
          } else {
            reject(response.text ? response.text : response);
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error.data ? error.data : error);
          }
        });
    });

  }

  submitHorseShowEntriesCanadaWithoutPayment(amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[]): Promise<Submitted_entries_receipt> {

    const post_data = {
      data: {
        type: 'submitted_horse_show_entries',
        new: true,
        attributes: { amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list, additional_items: additional_item_list }
      }
    };

    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries_canada_without_payment',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response.data && response.type === 'submitted_entries_receipt') {
            resolve(response.data);
          } else {
            reject(response.text ? response.text : response);
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error.data ? error.data : error);
          }
        });
    });

  }

  submitHorseShowEntriesWithoutPayment( amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[]): Promise<Submitted_entries_receipt> {

    let post_data = {
               data: {
                 type: 'submitted_horse_show_entries',
                 new: true,
                 attributes: {amount: amount, horse_show_id: horse_show_id, horse_show_entry_id_list: entry_id_list, additional_items: additional_item_list}
                 }
             };

             return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'submit_horse_show_entries_without_payment',
               post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

                    if(response.data && response.type=='submitted_entries_receipt') {
                        resolve(response.data);
                      } else {
                        if(response.text){
                          reject(response.text);
                        } else {
                         reject(response);
                       }
                      }

               }, error => {
                 if(error instanceof HttpErrorResponse){
                   reject(error.error);
                 } else {
                   reject(error.data ? error.data : error);
                 }
            });

       });


 }

}
